export const emailSettings = {
  emailTemplates: "Email templates",
  mailer: "Mailer",
  automaticNotifications: "Automatic notifications"
};
